import { getSettingsOptions } from '@/features/settings/settings.queries';
import { getUserOptions } from '@/features/user/user.queries';
import { createFileRoute, redirect } from '@tanstack/react-router';

import AppLayout from '@/components/app-layout';

export const Route = createFileRoute('/_app')({
  component: AppLayout,
  beforeLoad: async ({ context }) => {
    const [{ user }] = await Promise.all([
      context.queryClient.ensureQueryData(getUserOptions),
      context.queryClient.ensureQueryData(getSettingsOptions),
    ]);

    if (!user) {
      throw redirect({
        to: '/login',
      });
    }
  },
});
